module.exports = __webpack_public_path__ + "img/12_104.fe286e75.png";